/**
 * 辞书研究
 */
import request from '@/api/request'
const dictionaryResearchApi = {}

/**
 * 列表数据
 */
dictionaryResearchApi.getDicResearchList = param => {
  return request({
    url: '/function/journal/list',
    method: 'GET',
    params: param
  })
}

/**
 * 新增
 */
dictionaryResearchApi.addDicResearch = params => {
  return request({
    url: '/function/journal',
    method: 'POST',
    data: params
  })
}
/**
 * 置顶
 */
dictionaryResearchApi.setToTop = param => {
  return request({
    url: '/function/journal/setTopOne',
    method: 'GET',
    params: param
  })
}

/**
 * 删除
 */
dictionaryResearchApi.deleteDicResearch = params => {
  return request({
    url: '/function/journal/remove',
    method: 'POST',
    data: params
  })
}

/**
 * 根据ID查询详情
 */
dictionaryResearchApi.queryDicResearchDetailByID = param => {
  return request({
    url: '/function/journal',
    method: 'GET',
    params: param
  })
}

/**
 * 期刊 置顶
 */
dictionaryResearchApi.setToTopMagazine = param => {
  return request({
    url: '/function/journal/setTopOne',
    method: 'GET',
    params: param
  })
}

/**
 * 更新数据
 */
dictionaryResearchApi.updateDicResearch = params => {
  return request({
    url: '/function/journal',
    method: 'PUT',
    data: params
  })
}

//= ==================================================================================================
/**
 * 期刊文章列表
 */
dictionaryResearchApi.getMagazineDicResearch = param => {
  return request({
    url: '/function/article/list',
    method: 'GET',
    params: param
  })
}

/**
 * 获取期刊文章 详细信息
 */
dictionaryResearchApi.getMagazineResearchById = param => {
  return request({
    url: '/function/article',
    method: 'GET',
    params: param
  })
}

/**
 * 编辑 期刊文章
 */
dictionaryResearchApi.updateMagazineDicResearch = params => {
  return request({
    url: '/function/article',
    method: 'PUT',
    data: params
  })
}

/**
 * 新增期刊
 */
dictionaryResearchApi.addMagazineDicResearch = params => {
  return request({
    url: '/function/article',
    method: 'POST',
    data: params
  })
}

/**
 * 删除期刊文章
 */
dictionaryResearchApi.deleteMagazineDicResearch = params => {
  return request({
    url: '/function/article/remove',
    method: 'POST',
    data: params
  })
}

/**
 * 置顶期刊文章
 */
dictionaryResearchApi.setToTop = param => {
  return request({
    url: '/function/article/setTopOne',
    method: 'GET',
    params: param
  })
}

/**
 * 获取下拉年\期
 */
dictionaryResearchApi.getSelectMagazine = param => {
  return request({
    url: '/function/article/getSelect',
    method: 'GET',
    params: param
  })
}

// 上传接口
dictionaryResearchApi.upLoadData = param => {
  return request({
    url: '/common/upload',
    method: 'POST',
    data: param
  })
}

export default dictionaryResearchApi
